import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Apply persisted accessibility settings before first render
if (localStorage.getItem('a11y_highContrast') === 'true') {
  document.documentElement.classList.add('accessibility-mode');
}
if (localStorage.getItem('a11y_linkHighlight') === 'true') {
  document.documentElement.classList.add('link-highlight');
}
const savedFontSize = localStorage.getItem('a11y_fontSize');
if (savedFontSize === 'sm') document.documentElement.classList.add('font-sm');
if (savedFontSize === 'lg') document.documentElement.classList.add('font-lg');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register the service worker to enable offline caching and PWA install support.
// To disable the service worker, change this to serviceWorkerRegistration.unregister()
serviceWorkerRegistration.register();
